import * as Sentry from '@sentry/browser';
import { loggerService } from '@/_services/loggerService';

const WEAVR_TOKEN_KEY = "wv_token";
const WEAVR_USER_ID_KEY = "wv_user_id";

export const getToken = () => {
  return window.localStorage.getItem(WEAVR_TOKEN_KEY);
};

export const saveToken = (token) => {
  window.localStorage.setItem(WEAVR_TOKEN_KEY, token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(WEAVR_TOKEN_KEY);
};

export const getUserId = () => {
  return window.localStorage.getItem(WEAVR_USER_ID_KEY);
};

export const saveUserId = (userId) => {
  window.localStorage.setItem(WEAVR_USER_ID_KEY, userId);
  
  // Set the user identifier in Sentry
  if (userId) {
    Sentry.setUser({ id: userId });
  }
};

export const destroyUserId = () => {
  window.localStorage.removeItem(WEAVR_USER_ID_KEY);
};

export const saveAuthentication = (token, userId) => {
  saveToken(token);
  saveUserId(userId);
  
  // Log successful authentication
  loggerService.info('User authenticated', { userId });
  
  // Add authentication event to Sentry breadcrumbs
  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'User authenticated successfully',
    level: 'info',
    data: {
      userId
    }
  });
}

export const loggedIn = () => {
  return (getToken() && getUserId());
}

export const logout = () => {
  const userId = getUserId();
  
  destroyToken();
  destroyUserId();
  
  // Clear user information from Sentry
  Sentry.setUser(null);
  
  // Log logout event
  loggerService.info('User logged out', { userId });
  
  // Add logout event to Sentry breadcrumbs
  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'User logged out',
    level: 'info'
  });
}

const weavrAuthenticationStorage = {
  getToken,
  saveToken,
  destroyToken,
  getUserId,
  saveUserId,
  destroyUserId,
  saveAuthentication,
  loggedIn,
  logout
};

export default weavrAuthenticationStorage;